<div class="grid grid-cols-[1fr_auto_1fr] md:flex md:flex-row w-full items-center px-5 flex-wrap mt-4">
    <div class="flex flex-row items-center gap-x-4 mt-4 justify-self-start">
        <div id="boxPlan_header_title">
            <div
                class="boxPlan__header__title text-base flex flex-row items-center justify-center"
                [class.boxPlan__header__title__detailsActive]="planType() === PlanTypeEnum.BOX">
                @if (cassettes().length) {
                    <span class="block text-base">
                        {{ `synopticPlan.${planType()}` | transloco }}
                    </span>
                }

                <span> {{ headerValue() }}</span>
            </div>

            @if (cassettes().length) {
                <div class="boxPlan__header__details">
                    <div class="boxPlan__header__details__content">
                        <div>
                            <p>{{ 'synopticPlan.externalCode' | transloco }}</p>
                            <p>{{ this.selectedNode().dataNode.externalCode || 'N/A' }}</p>
                        </div>
                        <div>
                            <p>{{ 'synopticPlan.numberOfCassettes' | transloco }}</p>
                            <p>{{ cassettes().length }}</p>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>

    <div class="flex flex-row flex-grow items-center gap-3 mt-4 justify-self-center sm:flex-wrap">
        <app-button
            class="pointer-events-auto"
            [icon]="['fas', 'rotate']"
            [label]="'synopticPlan.reset' | transloco"
            [matMenuTriggerFor]="hasSelection() ? null : resetMenu"
            [type]="hasSelection() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
            (onClick)="hasSelection() ? resetFibering.emit(FiberingSideEnum.SELECTION) : null" />
        <mat-menu #resetMenu="matMenu">
            <button
                mat-menu-item
                (click)="resetFibering.emit(FiberingSideEnum.ENTERING)">
                {{ 'synopticPlan.entranceExitBox' | transloco: { SIDE: 'entrance' } }}
            </button>
            <button
                mat-menu-item
                (click)="resetFibering.emit(FiberingSideEnum.OUTGOING)">
                {{ 'synopticPlan.entranceExitBox' | transloco: { SIDE: 'exit' } }}
            </button>
            <button
                mat-menu-item
                (click)="resetFibering.emit(FiberingSideEnum.ALL)">
                {{ 'synopticPlan.entranceExitBox' | transloco }}
            </button>
        </mat-menu>

        <app-button
            class="pointer-events-auto"
            [disabled]="hasSelection()"
            [icon]="['fas', 'badge-check']"
            [label]="'synopticPlan.checkFibering' | transloco"
            [tooltip]="hasSelection() ? ('synopticPlan.disabledFiberingCheck' | transloco) : ''"
            [type]="ButtonType.SECONDARY"
            (onClick)="checkFibering.emit()" />

        <app-button
            class="pointer-events-auto"
            [disabled]="!hasSelectedCassette()"
            [icon]="['fas', 'pen']"
            [label]="'synopticPlan.updatePositions' | transloco"
            [tooltip]="!hasSelectedCassette() ? ('editMode.noCassetteSelected' | transloco) : ''"
            [type]="hasSelectedCassette() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
            (onClick)="updatePositions.emit()" />

        <app-button
            class="pointer-events-auto"
            [icon]="['fas', 'diagram-sankey']"
            [label]="'synopticPlan.automaticFibering' | transloco"
            [matMenuTriggerFor]="hasSelection() ? null : autoFiberingMenu"
            [type]="hasSelection() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
            (onClick)="hasSelection() ? automaticFibering.emit(FiberingSideEnum.SELECTION) : null" />
        <mat-menu #autoFiberingMenu="matMenu">
            <button
                mat-menu-item
                (click)="automaticFibering.emit(FiberingSideEnum.ENTERING)">
                {{ 'synopticPlan.entranceExitBox' | transloco: { SIDE: 'entrance' } }}
            </button>
            <button
                mat-menu-item
                (click)="automaticFibering.emit(FiberingSideEnum.OUTGOING)">
                {{ 'synopticPlan.entranceExitBox' | transloco: { SIDE: 'exit' } }}
            </button>
            <button
                mat-menu-item
                (click)="automaticFibering.emit(FiberingSideEnum.ALL)">
                {{ 'synopticPlan.entranceExitBox' | transloco }}
            </button>
        </mat-menu>
    </div>

    <div
        class="boxPlan__header__filter__display flex flex-row ml-6 mt-4 gap-2 items-center justify-self-end sm:flex-wrap">
        <div class="flex flex-row items-center gap-1">
            <app-button
                class="pointer-events-auto"
                [disabled]="!boxPlanEditModeStateService.canCancel()"
                [icon]="['fas', 'undo']"
                [tooltip]="(boxPlanEditModeStateService.canCancel() ? 'undoLastAction' : 'nothingToUndo') | transloco"
                [type]="ButtonType.SECONDARY"
                (onClick)="undoFibering.emit()" />

            <app-button
                class="pointer-events-auto"
                [disabled]="!boxPlanEditModeStateService.canReapply()"
                [icon]="['fas', 'rotate-right']"
                [tooltip]="(boxPlanEditModeStateService.canReapply() ? 'redoLastAction' : 'nothingToRedo') | transloco"
                [type]="ButtonType.SECONDARY"
                (onClick)="redoFibering.emit()" />

            <app-button
                class="pointer-events-auto"
                [disabled]="!boxPlanEditModeStateService.canReapply() && !boxPlanEditModeStateService.canCancel()"
                [icon]="['fas', 'check']"
                [type]="ButtonType.SECONDARY"
                (onClick)="validateFibering.emit()" />
        </div>

        <div class="flex items-center gap-2 pl-2">
            {{ 'synopticPlan.fiberingEdition' | transloco }}
            <app-toggle
                [checked]="true"
                (toggled)="leaveEditMode.emit()" />
        </div>
    </div>
</div>
